import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { IconUserOff } from "@tabler/icons-react";
import { useState } from "react";
import Functions from "../../../../callable/functions";
import Usuario from "../../../../models/usuario";
import { useSnackBar } from "../../../../stores/snackBarStores";

type Props = {
  colaborador: Usuario;
  open: boolean;
  onClose: (success: boolean) => void;
};
export default function ExcluircolaboradorDialog({
  colaborador,
  open,
  onClose,
}: Props) {
  const [excluindo, setExcluindo] = useState(false);
  const snackBar = useSnackBar();

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle color="text.primary">
        <Box display="flex" flexDirection="row" alignItems="center">
          <Box mr={1}>
            <IconUserOff size={16} />
          </Box>
          <Typography variant="h4">
            Remover o acesso de {colaborador.nome}?
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Ele não poderá mais fazer login através do email {colaborador.email}.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} color="inherit">
          Cancelar
        </Button>
        <LoadingButton
          color="error"
          variant="contained"
          loading={excluindo}
          onClick={async () => {
            setExcluindo(true);
            new Functions()
              .excluirUsuario({
                colaboradorId: colaborador.id,
              })
              .finally(() => {
                snackBar({
                  type: "ALERT",
                  payload: {
                    mensagem: `O acesso de ${colaborador.nome} foi removido.`,
                    severidade: "success",
                  },
                });
                setExcluindo(false);
                onClose(true);
              });
          }}
        >
          Remover Acesso
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
